module.exports = __webpack_public_path__ + "../assets/fonts/Neutra2Text-Demi.ffd7e677d9972b336c87bda381f2a67b.otf";